import { i18nTranslationHelper } from '@/i18n'
import { UpgradeEnrollmentResponse, UpgradeSettingsResponse } from './upgrade-service-types'
import { formatDate } from '@/main/helpers'

const t = {
  page: i18nTranslationHelper.getTPage
}

export const formatUpgradeRequestList = (
  response: UpgradeEnrollmentResponse
): UpgradeEnrollmentResponse => {
  const formattedItems = response?.items.map(item => {
    const getDiscountFormatName = (key: string | null | undefined) =>
      key
        ? t.page(`companyManager.upgradeEnrollment.modals.approve.discountInput.options.${key}`)
        : '--'

    return {
      ...item,
      formatOfDiscount: getDiscountFormatName(item.formatOfDiscount),
      createdAt: item.createdAt ? formatDate(new Date(item.createdAt)) : null,
      analyzedAt: item.analyzedAt ? formatDate(new Date(item.analyzedAt)) : null,
      signedAt: item.signedAt ? formatDate(new Date(item.signedAt)) : null,
      canceledAt: item.canceledAt ? formatDate(new Date(item.canceledAt)) : null
    }
  })

  return {
    ...response,
    items: formattedItems
  }
}

export const formatUpgradeRequestSettings = (
  response: UpgradeSettingsResponse
): UpgradeSettingsResponse => {
  // `response` (body.data) pode chegar nulo/ausente em prod apesar do tipo — era
  // exatamente a causa do crash `evaluating 'response.chargeTypes'`. Mantemos o
  // optional chaining em ambos os níveis como proteção de runtime.
  const formattedChargeTypes = response?.chargeTypes?.map(item => {
    const translationKey = `companyManager.upgradeEnrollment.modals.approve.discountInput.options.${item.type}`
    return {
      ...item,
      name: t.page(translationKey) || item.name
    }
  })

  return {
    ...response,
    chargeTypes: formattedChargeTypes ?? []
  }
}
